/**
 * author: Soumya Shreyas
 */
import React, { useEffect, useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import "./SupplierList.scss";
import { withTranslation } from "react-i18next";
import moment from "moment";
import SupplierService from "../../../core/service/SupplierService";
import { FcFinePrint } from "react-icons/fc";

import {
  Button,
  Table,
  Form,
  Badge,
  Modal,
  OverlayTrigger,
} from "react-bootstrap";

import {
  BiDownload,
  BiShareAlt,
  BiMenuAltRight,
  BiSearch,
  BiChevronDown,
  BiSort,
  BiInfoCircle,
  BiPlus,
} from "react-icons/bi";
import { MdSort } from "react-icons/md";
import { CgSortAz } from "react-icons/cg";
import TotalSuppliers from "../TotalSuppliers/TotalSuppliers";
import RiskPriority from "../RiskPriority/RiskPriority";
import OnboardingStatus from "../OnboardingStatus/OnboardingStatus";
import Pagination from "../../../components/Pagination/Pagination";
import { toast } from "react-toastify";
import CompanyListingEditDropdown from "../../../components/CompanyListingEditDropdown";
import InvitationService from "../../../core/service/InvitationService";
import {
  DEFAULT_ITEMS_PER_PAGE,
  SORT_ORDER_DESC,
  LIST_DEF_SORT,
  STATUS,
} from "../../../core/constants/common";
import ErrorHandlingService from "../../../core/service/ErrorHandlingService";
import ShareFormModal from "../ShareFormModal/ShareFormModal";
import { RegulationContext } from "../../../App";
import nodataimg from "../../../images/nodatafound.png";
import SubmissionStatusModal from "../SubmissionStatusModal/SubmissionStatusModal";
import Utils from "../../../core/utilities/Utils";
import SupplierListingCards from "../SupplierListingCards/SupplierListingCards";
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import { Dropdown } from 'react-bootstrap';



function SupplierList({ t }) {
  const navigate = useNavigate();
  const [supplierList, setSupplierList] = useState([]);
  const [itemsTotalCount, setItemTotalCount] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(DEFAULT_ITEMS_PER_PAGE);
  const [currentPage, setCurrentPage] = useState(1);
  const [key, setKey] = useState("");
  const [order, setOrder] = useState(SORT_ORDER_DESC);
  const [sortField, setSortField] = useState(LIST_DEF_SORT);
  const [sendInvitationEmail, setSendInvitationEmail] = useState();
  const [showResendModal, setShowResendModal] = useState(false);
  const [sendInvitationId, setSendInvitationId] = useState();
  const [isCheckAll, setIsCheckAll] = useState(false);
  const [isCheck, setIsCheck] = useState([]);
  const [isShare, setIsShare] = useState(false);
  const [selCompanies, setSelCompanies] = useState([]);
  const [isSubmissionStatus, setIsSubmissionStatus] = useState(false);
  const [submission, setSubmission] = useState("");
  const { glbRegulation, setGlbRegulation, glbRegulations } =
    useContext(RegulationContext);

  const [show, setShow] = useState(false);
  const [inviteId, setInviteId] = useState("");
  const [revokeItem, setRevokeItem] = useState("");
  const [showConfirmation, setShowConfirmation] = useState(false);
  const glbRegulationId = glbRegulation?.id ? glbRegulation.id : "";
  let messageConfirmation = t("RevokeConfirmationMessage.label");
  const [statusKey, setStatusKey] = useState("");
  const [email, setEmail] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [isSubOpen, setSubIsOpen] = useState(false);
  const [isNameOpen, setNameIsOpen] = useState(false);
  const [isStatusOpen, setStatusIsOpen] = useState(false);
  const [isEmailOpen, setEmailOpen] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [searchKey, setSearchKey] = useState("");
  const [supplierFilteredList, setSupplierFilteredList] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);


  const handleClose = () => setShow(false);
  const handleResendConfirm = () => {
    setShow(false);

    resendInvitaion();
  };

  useEffect(() => {
    getSuppliers(0, itemsPerPage, key, sortField, statusKey, email);
  }, [glbRegulationId]);

  const resendInvitaion = () => {
    InvitationService.resendInvitation(sendInvitationId)
      .then((response) => {
        if (response.status === 200) {
          toast.success("Sent Invitation", {
            position: toast.POSITION.TOP_RIGHT,
          });
          getSuppliers(currentPage, itemsPerPage, key, sortField, statusKey, email);
        }
      })
      .catch((error) => {
        //ErrorHandlingService.handleError(error.response.status);
        // console.log("err", error);
      });
  };
  const getSuppliers = (pageNumber, itemsPerPageVal, searchKey, sortField, statusKey, email) => {
    if (pageNumber > 0) {
      pageNumber = pageNumber - 1;
    } else {
      setCurrentPage(1);
    }
    let extraParams = {};
    if (glbRegulation?.code === "LKSG") {
      extraParams.regulationId = glbRegulation.id;
      //TODO remove hard coded value
      extraParams.period = Utils.recentDate;
    }

    let perPage = itemsPerPage;
    if (itemsPerPageVal > 0) {
      perPage = itemsPerPageVal;
    }
    let data = JSON.parse(localStorage.getItem("authority"));
    const company = data.profile.company.id;
    let sort = sortField + "," + order;
    SupplierService.listSupplier(
      pageNumber,
      perPage,
      key,
      sort,
      company,
      statusKey,
      email,
      extraParams
    )
      .then((response) => {
        let totalPages = parseFloat(response.headers["x-total-count"]);
        setItemTotalCount(totalPages);
        setSupplierList([...response.data]);
        // console.log(response.data);
      })
      .catch((error) => {
        //ErrorHandlingService.handleError(error.response.status);
        // console.log("err", error);
      });
  };
  const handleSearch = (e) => {
    let searchKey = e.target.value;
    setKey(searchKey);
    getSuppliers(0, itemsPerPage, searchKey, sortField, statusKey, email);
  };
  const handleSort = (val) => {
    if (sortField === val && order === "asc") {
      setOrder("desc");
    } else {
      setOrder("asc");
    }
    setSortField(val);
    getSuppliers(0, itemsPerPage, key, val, statusKey, email);
  };
  const handleSelectAll = (e) => {
    setIsCheckAll(!isCheckAll);
    setIsCheck(supplierList?.map((item) => item.invitationId));
    if (isCheckAll) {
      setIsCheck([]);
      setSelCompanies([]);
    }
  };
  const handleClick = (e) => {
    const { id, checked } = e.target;
    const itemId = id ? Number(id) : null;
    setIsCheck([...isCheck, itemId]);
    if (!checked) {
      setIsCheck(isCheck.filter((item) => item !== itemId));
    }
  };
  const handleShare = () => {
    setSelCompanies([]);
    var company = [];
    supplierList?.map((item) => {
      let comp = isCheck.includes(item.invitationId) && item.companyId;
      comp && company.push(comp);
    });
    setSelCompanies(company);
    setIsShare(true);
  };
  const callbackShare = () => {
    setIsShare(false);
  };
  const handleSubmissionStatus = (item) => {
    setSubmission(item);
    setIsSubmissionStatus(true);
  };
  const callbackSubmissionStatus = () => {
    setIsSubmissionStatus(false);
  };
  const handleCallbackRevoke = (item) => {
    setRevokeItem(item);
    setShowConfirmation(true);
  }
  const callbackRevoke = (val) => {
    setShowConfirmation(false);
    if (val) {
      InvitationService.resendInvitation(revokeItem, "REVOKED")
        .then((response) => {
          if (response.status === 200) {
            toast.success("Success", {
              position: toast.POSITION.TOP_RIGHT,
            });
            getSuppliers(0, itemsPerPage, key, sortField, statusKey, email);
          }
        })
        .catch((error) => { });
    }
  };
  var resendStatus = false;
  var editStatus = false;
  var sendInviteBool = false;
  var revokeStatus = false;

  const statusOpen = (e) => {
    setStatusIsOpen(!isStatusOpen);
    let statusKey = e;
    setStatusKey(statusKey);
  }

  const handleSelect = (event) => {
    const selectedOption = event.target.value;
    setStatusKey(selectedOption);
  }

  const emailOpen = () => {
    setEmailOpen(!isEmailOpen);
  }

  const handleSearchEmailKey = (e) => {
    setEmail(e.target.value);
  };

  const handleOptionDeselect = (option) => {
    setSelectedOptions((prevOptions) =>
      prevOptions.filter((prevOption) => prevOption !== option)
    );
  };

  const filterApply = () => {
    getSuppliers(0, itemsPerPage, searchKey, sortField, statusKey, email);
  }

  const handleReset = () => {
    setStatusKey("");
  };

  const clearFilter = () => {
    handleReset();
    setEmail("");
    getSuppliers(0, itemsPerPage, searchKey, sortField, "", "");
  }


  return (
    <>
      <div className="SupplierList">
        <div className="List_header">
          <h5 className="MH">{t("Suppliers.label")}</h5>
          <div className="List_sorts_menu">
            <ul>
              <li>
                <Link to="/company_admin/import_supplier">
                  <Button variant="secondary">
                    <BiDownload /> {t("Import.label")}
                  </Button>
                </Link>
              </li>
              <li>
                <Link to="/company_admin/create_supplier">
                  <Button variant="primary">
                    <BiPlus />
                    {t("New.label")}
                  </Button>
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="Supplier_status_01 pb-2">
          <div className="row px-1">
            <SupplierListingCards />
          </div>
        </div>

        <div className="List_Table_01 ">
          <div className="List_table-card01_head">
            <div className="List_table-card_Search_01">
              <div className="List_table-card_Search_Box">
                <Form>
                  <input
                    type="text"
                    className="form-control"
                    value={key}
                    onChange={handleSearch}
                    placeholder="Search by supplier name"
                  />
                  <Link to="#" className="Search_iocnBox">
                    <BiSearch />
                  </Link>
                </Form>
              </div>
            </div>
            <div className="List_table-card01_sort">
              <ul>
                {isCheck.length > 0 && <li>
                  <OverlayTrigger
                    placement="top"
                    overlay={Utils.renderTooltip(t("ShareAssessment.label"))}
                  >
                    <Link to="#" onClick={handleShare}>
                      <BiShareAlt /> {t("Share.label")}
                    </Link>
                  </OverlayTrigger>
                </li>}
                {/* <li>
                  <Link to="#">
                    <BiMenuAltRight /> {t("Sort.label")}
                  </Link>
                </li> */}
                <li className="filter">
                  <Link to="#">
                    <Dropdown className="filter_design" autoClose={false}>
                      <Dropdown.Toggle className="filter_btn" variant="secondary">
                        <CgSortAz /> {t("Filter.label")}
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="filter-dropdown-menu">
                        <div className="px-2">
                          <div className="pb-2">
                            <label>Onboarding Status</label>
                            <select className="form-select" value={statusKey} onChange={handleSelect}>
                              <option value="" selected>Select A status</option>
                              <option value="INVITED">Invited</option>
                              <option value="ACCEPTED">Accepted</option>
                              <option value="ONBOARDED">Onboarded</option>
                              <option value="DRAFT">Draft</option>
                            </select>
                          </div>
                          <div className="pb-2">
                            <label>Email</label>
                            <input
                              className="form-control"
                              type="text"
                              value={email}
                              onChange={handleSearchEmailKey}
                              placeholder="Search by email"
                            />
                            <div>
                              {selectedOptions.map((option) => (
                                <button type="button" className="btn btn-primary" key={option.invitationId}>
                                  {option.email}<button className="btn-close btn-close-white" color="none" aria-label="Close" onClick={() => handleOptionDeselect(option)} />
                                </button>
                              ))}
                            </div>
                          </div>
                          <div className="pb-2 text-center">
                            <button onClick={() => filterApply()} className="btn btn-primary">Apply</button>
                            <button onClick={() => clearFilter()} className="btn btn-secondary ms-2">Reset</button>
                          </div>
                        </div>


                      </Dropdown.Menu>

                    </Dropdown>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="card List_table-card01">
            <Table responsive="sm">
              <thead>
                <tr>
                  <th className="th_check">
                    <Form.Check
                      inline
                      name="selectAll"
                      type="checkbox"
                      id="selectAll"
                      onChange={handleSelectAll}
                      checked={isCheckAll}
                    />
                  </th>
                  <th>
                    <Link to="#" onClick={() => handleSort("legalName")}>
                      {t("SupplierName.label")}
                      <BiSort />
                    </Link>
                  </th>
                  <th>
                    <Link to="#" onClick={() => handleSort("email")}>
                      {t("Email.label")}
                      <BiSort />
                    </Link>
                  </th>
                  <th>{t("ContactNumber.label")}</th>
                  <th>
                    <Link to="#" onClick={() => handleSort("createdDate")}>
                      {t("CreatedDate.label")}
                      <BiSort />
                    </Link>
                  </th>
                  <th>
                    <Link to="#" onClick={() => handleSort("invitationStatus")}>
                      {t("Onboarding.label")}
                      <BiSort />
                    </Link>
                  </th>
                  {glbRegulation?.code === "LKSG" && (
                    <>
                      <th>{t("Assessments.label")}</th>
                      <th>{t("Risk.label")}</th>

                    </>
                  )}
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {supplierList.length > 0 ? (
                  supplierList?.map((item) => (
                    <tr key={item.invitationId}>
                      <td className="checkbox">
                        {" "}
                        <Form.Check
                          inline
                          key={item.invitationId}
                          name={item.legalName}
                          type="checkbox"
                          id={item.invitationId}
                          onChange={handleClick}
                          checked={isCheck.includes(item.invitationId)}
                        // checked={isCheck[item.invitationId]}
                        />
                      </td>
                      <td>
                        <span>
                          {item.invitationStatus !== "INVITED" ? (
                            item.companyId ? (
                              <OverlayTrigger
                                placement="top"
                                overlay={Utils.renderTooltip(
                                  t("Clicktoviewcompanydetails.label")
                                )}
                              >
                                <Link
                                  to={`/company_admin/supplier_profile/${item.companyId}`}
                                >
                                  {item.legalName}
                                </Link>
                              </OverlayTrigger>
                            ) : (
                              item.legalName
                            )
                          ) : (
                            <span>{item.legalName}</span>
                          )}
                          <p className="m-0">{item.countryName}</p>
                        </span>
                      </td>
                      <td>{item.email}</td>
                      <td>
                        +{item.phoneNumber.code.phoneCode}{" "}
                        {item.phoneNumber.number}
                      </td>
                      <td>{moment(item.createdDate).format("MMM DD, YYYY")}</td>
                      <td>

                        {(() => {
                          resendStatus = false;
                          editStatus = false;
                          revokeStatus = false;
                          switch (item.invitationStatus) {
                            case "ONBOARDED":
                              return (
                                <Badge bg="badge-Onboarded">
                                  {STATUS[item.invitationStatus]}
                                </Badge>
                              );
                            case "INVITED":
                              editStatus = true;
                              resendStatus = true;
                              sendInviteBool = true;
                              revokeStatus = true;
                              return (
                                <Badge bg="badge-Invited">
                                  {STATUS[item.invitationStatus]}
                                </Badge>
                              );
                            case "ACCEPTED":
                              return (
                                <Badge bg="badge-Accepted">
                                  {STATUS[item.invitationStatus]}
                                </Badge>
                              );
                            case "COMPLETED":
                              return (
                                <Badge bg="badge-Completed">
                                  {STATUS[item.invitationStatus]}
                                </Badge>
                              );
                            case "DRAFT":
                              editStatus = true;
                              sendInviteBool = false;
                              return (
                                <Badge bg="badge-Draft">
                                  {STATUS[item.invitationStatus]}
                                </Badge>
                              );
                            case "REJECTED":
                              editStatus = true;
                              resendStatus = true;
                              return (
                                <Badge bg="badge-Rejected">
                                  {STATUS[item.invitationStatus]}
                                </Badge>
                              );
                            default:
                              return " ";
                          }
                        })()}
                      </td>
                      {glbRegulation?.code === "LKSG" && (
                        <>
                          <td>
                            {/* 3/3{" "} */}

                            <OverlayTrigger
                              placement="top"
                              overlay={Utils.renderTooltip(
                                t("AssessmentSubmissionStatusMessage.label")
                              )}
                            >
                              <Link to="#">
                                <BiInfoCircle className="Font-20"
                                  onClick={() =>
                                    handleSubmissionStatus(item)
                                  }
                                /> View Details
                              </Link>
                            </OverlayTrigger>
                          </td>
                          <td>
                            <span
                              style={{ color: item.resultConfig?.colorCode }}
                            >
                              {item.resultConfig?.resultType}
                            </span>
                          </td>
                        </>
                      )}
                      <td>
                        {(editStatus || resendStatus) && (
                          <CompanyListingEditDropdown
                            editStatus={editStatus}
                            resendStatus={resendStatus}
                            revokeStatus={revokeStatus}
                            invitation={item.invitationId}
                            handleResend={() => {
                              setSendInvitationId(item.invitationId);
                              setShow(true);
                              setSendInvitationEmail(item.email);
                            }}
                            handleEdit={() => {
                              const myData = {
                                id: item.invitationId,
                                legalName: item.legalName,
                                name: item.contactName,
                                email: item.email,
                                contactNumber: {
                                  id: item.phoneNumber.code.id,
                                  code: {
                                    id: item.phoneNumber.code.phoneCode,
                                    name: item.phoneNumber.code.name,
                                  },
                                  number: item.phoneNumber.number,
                                },
                                sendInvite: sendInviteBool,
                                supplierType: item.supplierType,
                              };
                              navigate("/company_admin/edit_supplier", {
                                state: myData,
                              });
                            }}
                            handleRevoke={() => {
                              handleCallbackRevoke(item.invitationId)
                            }}
                          />
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" className="text-center">
                      <div className="Nodatafound_box">
                        <h6><FcFinePrint className="me-2" /> {t("Nodatafound.label")}</h6>
                      </div>
                    </td>
                  </tr>
                )}
                <Modal show={show} onHide={handleClose}>
                  <Modal.Header closeButton>
                    <Modal.Title as="h5"></Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    {t("ResendInvitation.label") + " " + sendInvitationEmail}
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose} autoFocus>
                      {t("Cancel.label")}
                    </Button>
                    <Button variant="primary" onClick={handleResendConfirm} className="sbmBtn">
                      {t("Send.label")}
                    </Button>
                  </Modal.Footer>
                </Modal>
              </tbody>
            </Table>
            <div className="p-2 List_footer_count">
              <Pagination
                itemsTotalCount={itemsTotalCount}
                itemsPerPage={itemsPerPage}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                alwaysShown={true}
                setItemsPerPage={setItemsPerPage}
                pageClicked={(pageNum, perPage) => {
                  getSuppliers(pageNum, perPage, key, sortField, statusKey, email);
                }}
              />
            </div>
            {isShare && (
              <ShareFormModal
                isShare={isShare}
                list={selCompanies}
                callbackShare={callbackShare}
              />
            )}
            {isSubmissionStatus && (
              <SubmissionStatusModal
                isSubmissionStatus={isSubmissionStatus}
                submission={submission}
                callbackSubmissionStatus={callbackSubmissionStatus}
              />
            )}
            {showConfirmation && (
              <ConfirmationModal
                modalShow={true}
                messageText={messageConfirmation}
                callbackModal={callbackRevoke}
                confirmBtn={t("Confirm.label")}
                CancelBtn={t("Cancel.label")}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default withTranslation()(SupplierList);
